'use client'

import { type ComponentProps } from 'react'

import { useAds } from '@/components/providers/AdsProvider'
import { AD_GLOBAL_STATUS } from '@/defs/ad'

import { AdInHouse } from '../AdInHouse/AdInHouse'

type Props = Omit<ComponentProps<typeof AdInHouse>, 'id' | 'unit' | 'utm'>

export const AdMidBanner = (props: Props) => {
  const { adsDisabled } = useAds()

  if (adsDisabled || !AD_GLOBAL_STATUS.MID_BANNER) return null

  return <AdInHouse {...props} id='csHobbit' unit='midbanner' utm={{ medium: 'mid_banner' }} />
}
